import React, { memo } from 'react'
import { Box, Stack } from '@mui/material'
import { faLockKeyhole } from '@fortawesome/pro-duotone-svg-icons'

import ProgressTitle from '../shared/progressBar/ProgressTitle'
import ProviderIcon from '../shared/exchangeProviderCard/ProviderIcon'
import { Label } from '../shared/label'
import { formatTicks } from '../../util/string.helpers'
import Button from '../shared/button/Button'
import SelectPerkActions from './SelectPerkActions'

const PerkItem = ({ t, id, productId, amount, onOpenPerk }) => {
  const name = t(`brand:perk.list.${id}.title`)
  return (
    <Box
      sx={{
        gap: 2,
        display: 'flex',
        alignItems: 'center',
        flexDirection: { sm: 'row' }
      }}
    >
      <ProviderIcon
        size={56}
        src={`/assets/perks/${id}.jpg`}
        variant='rounded'
      />
      <Stack spacing={0.5} flexGrow={1} alignItems='flex-start'>
        <ProgressTitle name={name} />
        {amount > 0 ? (
          <Label color='primary'>{`${t('transaction-history.amount')}: $${formatTicks(amount)}`}</Label>
        ) : (
          <Label color='default' endIcon={faLockKeyhole}>
            {t('brand:perk.status-locked')}
          </Label>
        )}
      </Stack>
      {productId.length > 1 ? (
        <SelectPerkActions
          productId={productId}
          onSelectPerk={onOpenPerk}
          t={t}
          disabled={!amount}
        />
      ) : (
        <Button
          label={t('brand:perk.redeem')}
          size='small'
          onClick={() => onOpenPerk({ id, name })}
          sx={{ width: 88 }}
          disabled={!amount}
        />
      )}
    </Box>
  )
}

export default memo(PerkItem)
